import './Loader.css'
import styled, { keyframes } from 'styled-components'

//loader pour useFetch (appel api)
const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`

export const Loader = styled.div`
  animation: ${rotate} 1s infinite linear;`
